const props = {
	timeEnabled: {
		type: Boolean,
	},
	timeStart: {
		type: String
	},
	timeEnd: {
		type: String
	},
	timeUrlStyle: {
		type: String
	},
	timeDefault: {
		type: [String, Number],
	}
}

const methods = {
	timeChanged(start, end) {
		let PARAMS = this.compileParams(start, end);
		this.$source.updateParams({ "ENV":PARAMS });
	},
	compileParams(s, e) {
		var PARAMS = '';
		if (this.timeStart && typeof s !== 'undefined') {
			PARAMS += this.timeStart + ":" + String(s) + ";";
		}
		if (this.timeEnd && typeof e !== 'undefined') {
			PARAMS += this.timeEnd + ":" + String(e) + ";";
		}
		return PARAMS;
	}
}

export default {
  props,
  methods
}


// WEBPACK FOOTER //
// ./resources/js/map/MapComponents/mixins/layers/time-enabled.js